import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import io from 'socket.io-client';

import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-online-users',
  templateUrl: './online-users.component.html',
  styleUrls: ['./online-users.component.scss']
})
export class OnlineUsersComponent implements OnInit {
  
  @Output() sendData = new EventEmitter<any>();
  
  display = false
  users: any = []
  usersData: any = [];
  userHolder: any 
  socket: any;
  


  constructor(
    private dataService: DataService,
    
    ) { }

  ngOnInit(): void {
    Promise.all([
      this.firsReload(),
      this.getSocket(),
      this.getData(),
    ])
  }

  openForm() {
    this.display = true
  }

  async firsReload() {
    if (window.localStorage) {
      if (!localStorage.getItem('firstLoad')) {
        localStorage['firstLoad'] = true;
        window.location.reload();
      }
      else
        localStorage.removeItem('firstLoad');
    }
    return
  }

  getSocket = async () => {
    try {
      if(!GlobalConstants.socketStatus) {
        this.socket = io(GlobalConstants.socketURL);
        this.socket.on('updateUserStatus', (data: any) => {
          this.users = data
        })
      }

    } catch (error) {
      console.log(error)
    }
  }

  

  getData = async () => {
    try {
      const res = await this.dataService.getData('user')
      if (!res.error) this.usersData = res.data
      console.log("===>Ueer DATA =>",this.usersData,res.data)
    } catch (error) {
      console.log(error)
    }
  }


  //activateUser Fucnction
  activateUser = async (id: string) => {
    if(!id || !this.usersData) return
    this.userHolder = this.usersData.find((e : any)=>{ return e._id == id})
    this.sendData.emit(this.userHolder)
    console.log("id==>",id,this.userHolder,this.usersData);
    // this.dialog.open(DetailModalComponent, {data : id })
    //  .afterClosed()
    //  .subscribe();
  }

  closeForm() {
    this.display = false
  }

}
